import { getLocationNameFromId } from "../../lib/labels"
import { formatDateLocal } from "../../lib/script"
import Tag from "../fragments/Tag"

import SimpleCopyTextButton from "../common/SimpleCopyTextButton";
import TableNameLink from "../common/TableNameLink";
import CancelTransfer from "./CancelTransfer";
import CompleteTransfer from "./CompleteTransfer";
import DatepickerWithLabel from "../common/interactive/DatepickerWithLabel";
import { updateTransferRequest } from "../../lib/fetchApi";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { notificationActions } from "../../store/notifications";
import { transfersActions } from "../../store/transfers";

export default function TransfersRow({data}) {
    const COLROS = {
        Pending: 'yellow',
        Completed: 'green',
        Review: 'red'
    }

    const userToken = useSelector(state => state.user.token)
    const editPermissions = useSelector(state => state.permissions.editPermissions)
    const canCompleteTransfer = !!editPermissions?.practice_complete_transfer
    const dispatch = useDispatch()

    const updateHandler = async (value) => {
        let reqBody = {
            first_appointment_date: value.data.value
        }


        let updateTransfer = await updateTransferRequest(userToken, data?.case_id, data?.id, reqBody, null)
        if (updateTransfer && updateTransfer.errorMessage) {
            dispatch(notificationActions.setError(updateTransfer))     
        } else {  
            dispatch(transfersActions.setRefreshApi())          
            dispatch(notificationActions.setError({errorMessage: `Transfer Updated!`, type: 'success'}))    
        }
    }


    return <tr>
        <td><SimpleCopyTextButton textToCopy={data?.patient?.person_number} /></td>
        <td className="table-cell-no-padding">
            <TableNameLink text={data?.patient?.name} case_id={data?.case_id} case_data={data}/>        
        </td>
        <td>{getLocationNameFromId(data?.from_location_id)}</td>
        <td>{getLocationNameFromId(data?.to_location_id)}</td>
        <td>
            <Tag color={COLROS[`${data.status}`]}>{data.status}</Tag>
            
        </td>
        <td>{data.reason}</td>
        <td style={{backgroundColor: '#fff'}}>
            {/* {formatDateLocal(data.first_appointment_date)} */}
            <DatepickerWithLabel defaultDate={data.first_appointment_date} setStyle={'simple'} action={updateHandler} minDate={new Date()}/>
        </td>
        <td className="table-cell-fit">
            {(data.status == 'Pending' || data.status == 'Review') ? (
                <div className="flex-container">
                    {canCompleteTransfer && (
                        <CompleteTransfer caseID={data?.case_id} transferData={data} />
                    )}
                    <CancelTransfer caseID={data?.case_id} transferData={data} />
                </div>
            ) : '-'}
        </td>
    </tr>
}
